<template>
  <div
    :class="{ 'bg-primary-background-active': active }"
    class="flex w-full cursor-pointer justify-start rounded-sm py-2 text-sm font-medium text-gray-600 hover:bg-primary-background-active"
    data-cy="side-menu-item"
  >
    <slot name="content">
      <div
        v-if="$slots.icon"
        class="flex items-center justify-center pl-3"
        :class="{ 'text-primary': active }"
      >
        <slot name="icon" />
      </div>
      <div class="pr-7 pl-4 text-left" :class="classes">
        <slot />
      </div>
    </slot>
  </div>
</template>

<script setup lang="ts">
defineProps({
  active: {
    type: Boolean,
    default: false,
  },
  classes: {
    type: String,
    default: "",
  },
});
</script>
